import React, { useEffect } from "react";
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import config from '../../../config/configJS';

const MessageSourceModal = ({ meta, extractionTaskId }) => {

    const [t, ] = useTranslation('global');
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <div className="modal-item" >
                {meta.folder && <span className="source-folder-chip" title={meta.folder}>{meta.folder}</span>}
                <span onClick={handleOpen}>
                    {meta.f}
                    <span className="material-symbols-outlined source-item-icon">
                        search
                    </span>
                </span>
                {meta.s !== null ? (
                    <a
                        target="_blank"
                        href={meta.s}
                        className="material-symbols-outlined download-item-icon"
                    >
                        open_in_new
                    </a>
                ) : (
                    <a
                        target="_blank"
                        href={`${config.endPoint}/api/millai/DownloadFile?intent=GetFileById&id=${extractionTaskId}`}
                        className="material-symbols-outlined download-item-icon"
                    >
                        download
                    </a>
                )}
            </div>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
                <div className="msg-source-modal-content">
                    {meta.folder && <p><b>{t('folder')}</b>: {meta.folder} </p>}
                    <p><b>{t('fileName')}</b>: {meta.f} </p>
                    <p><b>{t('fileNumber')}</b>: {meta.n} </p>
                    <p><b>{t('filePage')}</b>: {meta.p} </p>
                    <p><b>{t('fileChunk')}</b>: {meta.c}</p>
                </div> 
            </Modal> 
        </>       
    );
}

export default MessageSourceModal;